<template>
  <!-- 数据纠错 -->
  <el-dialog append-to-body width="38%" :title="$t('companyDetail.datachangeError')" :visible.sync="Dataerrorcorrection" destroy-on-close>
    <el-form :rules="rules" ref="formdata" :model="formdata" label-width="90px">
      <el-form-item :label="$t('companyDetail.replyEmail')" prop="emaile">
        <el-input :placeholder="$t('companyDetail.enterEmail')" v-model="formdata.emaile"></el-input>
      </el-form-item>
      <el-form-item :label="$t('companyDetail.contactPhone')" prop="telephone">
        <el-input :placeholder="$t('companyDetail.enterPhone')" v-model="formdata.telephone"></el-input>
      </el-form-item>
      <el-form-item :label="$t('companyDetail.questionDse')" prop="desc">
        <el-input :rows="6" type="textarea" :placeholder="$t('companyDetail.pageDes')" v-model="formdata.desc"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" class="sub-confirm-btn" @click="Dataerrorcorrection = false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" class="confirm-btn" @click="confirmMtji('formdata')">{{ $t('submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DatachangeErrorDialog',
  computed: {
    id() {
      return this.$route.params.id
    },
  },
  data() {
    return {
      formdata: {
        emaile: '',
        telephone: '',
        desc: '',
      },
      Dataerrorcorrection: false,
      rules: {
        emaile: [{ required: true, message: this.$i18.language('请输入回复邮箱'), trigger: 'blur' }],
        telephone: [{ required: true, message:this.$i18.language('请输入联系电话'), trigger: 'blur' }],
        desc: [{ required: true, message: this.$i18.language('请输入问题描述'), trigger: 'blur' }],
      },
    };
  },

  mounted() {
    
  },

  methods: {
    sjrtcu() {
      let data = {
        token: localStorage.getItem('accessToken'),
      }
      this.$api.dashboard.getUserInfo(data).then((res) => {
        if (res.code == 200) {
          let {email, mobile} = res.data
          this.formdata = {
            emaile: email,
            telephone: mobile,
            desc: '',
          }
          this.Dataerrorcorrection = true
        }
      })
    },
    confirmMtji(formdata) {
      this.$refs[formdata].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('message.confirm.dataChange'), this.$t('tips'), {
            confirmButtonText: this.$t('sure'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning',
          }).then(async () => {
            let {emaile, telephone, desc} = this.formdata
              const data = {
                id: this.id,
                type: 1, //1特易搜搜，2贸易情报
                emaile,
                telephone,
                data: desc,
              }
              let res = await this.$api.dashboard.saveMyDataCorrection(data)
              if (res.code == 200) {
                  this.Dataerrorcorrection = false
                  this.$message({
                    type: 'success',
                    message: this.$i18.language('数据纠错成功'),
                  })
                }
            }).catch(() => {
              this.Dataerrorcorrection = false
              this.$message({
                type: 'info',
                message: this.$i18.language('已取消数据纠错'),
              })
            })
        } else {
          return false
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>

</style>